// extracted by mini-css-extract-plugin
export default {"Insights":"SummaryInsights_Insights__59EHw"};